import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SimpleUserDto } from '../models/dto/simple-user.dto';
import { UserUtil } from '../utils/user.utils';
import { environment } from 'src/app/config/environments/environment';

declare var clarity: any;

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  constructor(private router: Router, private userUtil: UserUtil) {}

  init() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setEnvironment();
        this.identifyUser();
      }
    });
  }

  setEnvironment() {
    clarity('set', 'environment', environment.name);
  }

  identifyUser() {
    const user: SimpleUserDto = this.userUtil.getUser();
    if (user) {
      clarity('identify', user.email);
    }
  }
}
